export enum PrivacyEnum {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
  UNLISTED = 'UNLISTED',
  PARTNERSHIP = 'PARTNERSHIP',
  MATCHING_USER = 'MATCHING_USER',
}

export type PrivacyType = keyof typeof PrivacyEnum;
